import catalogData from './subscription_catalog.json';
import type {
  EntitlementId,
  ProductId,
  SubscriptionCatalog,
  SubscriptionProduct,
} from './types';

export const SUBSCRIPTION_CATALOG = catalogData as SubscriptionCatalog;

export const SUBSCRIPTION_PRODUCTS: SubscriptionProduct[] = SUBSCRIPTION_CATALOG.products;

export const ALL_ENTITLEMENT_IDS: EntitlementId[] = SUBSCRIPTION_CATALOG.entitlements;

export const BASELINE_ENTITLEMENT_IDS: EntitlementId[] =
  SUBSCRIPTION_CATALOG.baseline_entitlements;

export const ALL_PRODUCT_IDS: ProductId[] = SUBSCRIPTION_PRODUCTS.map((p) => p.id);

export function getProduct(id: ProductId): SubscriptionProduct | undefined {
  return SUBSCRIPTION_PRODUCTS.find((p) => p.id === id);
}

/** Entitlements a product grants, including the baseline every product grants. */
export function productGrants(id: ProductId): EntitlementId[] {
  const product = getProduct(id);
  if (!product) {
    return [];
  }
  return Array.from(new Set([...BASELINE_ENTITLEMENT_IDS, ...product.grants]));
}

/** Prerequisites for display only; the server fulfills any product at any time. */
export function productRequires(id: ProductId): EntitlementId[] {
  return getProduct(id)?.requires ?? [];
}

export function formatPriceCents(cents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
}
